module.exports = __webpack_public_path__ + "static/media/closeCross2.77e1885a.svg";